import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';
import Vpc from './vpc';

@Model()
export default class SecurityGroup extends ApplicationRecord {
  static jsonapiType = 'security_groups';
  @Attr() name: string;
  @Attr() vpcId: string;
  @Attr() identifier: string;
  @Attr({ persist: false }) selected: boolean;

  @BelongsTo() facility: Facility;
  @BelongsTo() vpc: Vpc;

  constructor(attrs?: Record<string, any>) {
    super(attrs);
    this.selected = false;
  }
}
